// extracted by mini-css-extract-plugin
module.exports = {"header":"CardHeader_header__qmq4f","icon":"CardHeader_icon__gr_mR","title":"CardHeader_title__xnJaZ"};